module.exports = __webpack_public_path__ + "static/media/Kuki Shinobu.ef220a61.png";